import { createAction, props } from '@ngrx/store';
import { Project } from '../models';

export const projectActions = {
  updateProject: createAction(
    '[Project] Update Project',
    props<{ project: Project }>()
  ),
};
